<template>
  <v-dialog persistent v-model="value" max-width="1000px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Emitir Pago</span>
      </v-card-title>
      <v-card-text style="max-height: 800px;">
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1">Concepto</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" :step="2">Audiencia</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :step="3">Previo</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <PaymentConcept 
                    :v="$v.paymentForm" />
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <PaymentAudience
                    :cancel="flags.cancel"
                    :_object="paymentForm"
                    v-on:selected="selectionAudiency"
                  />
                </v-stepper-content>
                <v-stepper-content :step="3">
                  <PaymentDetails :payment="paymentForm" :user="getUser" />
                </v-stepper-content>
              </v-stepper-items>
              <alert v-model="toast.alert" title="Aviso" :description="toast.description"></alert>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="disabled" :disabled="e1 == 1" color="primary" @click="back" icon>
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" @click="close" flat>Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" color="primary" @click="next" icon>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import PaymentConcept from "../Sections/Payments/PaymentConcept";
import PaymentAudience from "../Tools/AudiencePayment";
import PaymentDetails from "../Sections/Payments/PaymentDetails";
import alert from "../Dialogs/Alert";
export default {
  components: {
    PaymentConcept,
    PaymentAudience,
    PaymentDetails,
    alert,
  },
  validations: {
    paymentForm: {
      name: { required },
      paymentConcept: { required },
      dueDate: { required },
      metadata: { required },
    },
  },
  props: ["value"],
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false;
      }
    },
  },
  data: () => ({
    e1: 0,
    paymentForm: {
      name: "",
      paymentConcept: {
        id: "",
        name: "",
      },
      dueDate: "",
      metadata: {
        split: false,
        institutional: false,
      },
      levels: [],
      students: [],
      groups: [],
      subgroupIds: [],
      publish: false,
    },
    toast: {
      alert: false,
      description: "",
    },
    flags: {
      cancel: false,
      loading: false,
    },
    disabled: true,
  }),
  methods: {
    close() {
      this.paymentForm = {
        name: "",
        paymentConcept: {
          id: "",
          name: "",
        },
        dueDate: "",
        metadata: {
          split: false,
          institutional: false,
        },
        levels: [],
        students: [],
        groups: [],
        subgroupIds: [],
        publish: false,
      };

      this.flags.cancel = true;
      this.e1 = 1;
      this.$v.paymentForm.$reset();
      this.$emit("onClosed", false);
    },
    next() {
      switch (this.e1) {
        case 1:
          this.$v.paymentForm.name.$touch();
          this.$v.paymentForm.dueDate.$touch();
          this.$v.paymentForm.paymentConcept.$touch();
          if (
            !this.$v.paymentForm.name.$invalid &&
            !this.$v.paymentForm.dueDate.$invalid &&
            this.$v.paymentForm.paymentConcept.$model.id != ""
          ) {
            this.e1++;
          }
          break;
        case 2:
          if (
            this.paymentForm.students.length > 0 ||
            this.paymentForm.groups.length > 0 ||
            this.paymentForm.levels.length > 0 ||
            this.paymentForm.subgroupIds.length > 0 ||
            this.paymentForm.metadata.institutional
          ) {
            this.e1++;
          } else {
            this.toast.description =
              "Debes agregar ya sea la institución o al menos un nivel, grupo, subgrupo o estudiante";
            this.toast.alert = true;
          }
          break;
        case 3:
          this.createPayment();
          break;
      }
    },
    back() {
      this.e1--;
    },
    selectionAudiency(event) {
      this.paymentForm.levels = event.levels;
      this.paymentForm.groups = event.ggs;
      this.paymentForm.students = event.students;
      this.paymentForm.metadata.institutional = event.institutional;
      this.paymentForm.subgroupIds = event.subgroupIds;
    },
    createPayment() {
      this.disabled = false;
      this.$emit("loading");

      var payment = {
        name: this.paymentForm.name,
        dueDate: this.paymentForm.dueDate,
        apply: this.paymentForm.publish,
        split: this.paymentForm.metadata.split,
        idPaymentConcept: this.paymentForm.paymentConcept.id,
        institutional: this.paymentForm.metadata.institutional,
        levelIds: (this.paymentForm.levels || []).map((lvl) => lvl.id),
        gradeGroupIds: (this.paymentForm.groups || []).map((gg) => gg.id),
        subgroupIds: (this.paymentForm.subgroupIds || []).map((sg) => sg.id),
        studentIds: (this.paymentForm.students || []).map((std) => std.id),
      };

      this.$store
        .dispatch("payments/createPayment", payment)
        .then((response) => {
          this.disabled = true;
          this.$v.paymentForm.$reset();
          this.close();
          this.$emit("created", { success: true, payment: response.data });
        })
        .catch((error) => {
          this.disabled = true;
          this.$emit("created", { success: false, error: error });
        });
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.close();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
};
</script>

<style>
</style>
